import React from 'react';

import cx from 'classnames';

import Icon from '../Icon';
import Trash2 from '../Icon/icons/Trash2';
import Text from '../Typography/Text';
import s from './index.module.css';
import * as types from './types';

function ListItem({ title, status, isEditing, canDelete, onAction, onDelete, className }: types.Props) {
  return (
    <div className={cx(s.wrapper, className)}>
      <Text accent className={s.title}>
        {title}
      </Text>
      <div className={s.actions}>
        {status ? (
          <Text accent className={cx(s.edit, s.grey)}>
            {status}
          </Text>
        ) : (
          <div className={s.actionsContent}>
            <Text accent className={s.edit} onClick={onAction}>
              {isEditing ? 'Close' : 'Edit'}
            </Text>
            {canDelete && (
              <button type="button" className={s.delete} onClick={onDelete}>
                <Icon component={Trash2} />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ListItem;
